import {Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {FoEventsService} from "../event/foevents.service";
import {DomSanitizer, Meta} from "@angular/platform-browser";
import {AuthService} from "../../core/auth/auth.service";
import {LOCAL_STORAGE, WINDOW} from "@ng-toolkit/universal";
import {ActivatedRoute, Router} from "@angular/router";
import {BooKingservice} from "../booking/booking.service";
import {FonctionUtiles} from "../fonctionsUtiles";
/*import {FacebookService} from "ngx-facebook";*/
import {BookingList} from "../event/bookingList";
import {Ticket} from "../booking/ticket";
import {Order} from "../booking/order";
import {isPlatformBrowser} from "@angular/common";
import {ContactFormModalComponent} from "../contact-form-modal/contact-form-modal.component";

@Component({
  selector: 'app-event-inscription',
  templateUrl: './event-inscription.component.html',
  styleUrls: ['./event-inscription.component.css'],
  providers: [FoEventsService, BooKingservice]
})
export class EventInscriptionComponent implements OnInit {

  id: any;
  inscriptionId:any;
  Inscription:any;
  countdownStoped: boolean = false;
  event1: any;
  ticketNumber: number = 0;
  pricings: any;
  pricingGroups: any;
  dayname: string;
  hours: any;
  day: any;
  month: any;
  nbreTicket: any = 0;
  Total: any = 0;
  geocoder: any;
  latitude: any;
  longitude: any;
  positions: any[] = [];
  tickets: Ticket[] = [];
  bookingLists: BookingList[] = [];
  nbTicketArray = [];
  order: Order;
  diffdays: any;
  diffhour: any;
  diffminutes: any;
  datenow: any;
  organisaion: any;
  isEnd: boolean = false; // event start date past
  isClosed: boolean = false; // event closed date past => online ticketing end date
  selected: any = 'map';
  readMore: boolean = true;
  copyDisabled: boolean = false;
  galery: any;
  isSecret: boolean = false;
  password: string;
  unlockPassworderror: boolean = false;
  objectiveRate: number = 0;
  navigationSubscription;
  devise: any;
  front_event:any;
  daysarray: any = [];
  monthsarray: any = [];
  smartUrlId: string;
  ticketingsType: any = [];
  pricingsAndPrincingsInGroup: any;
  hasCodePromoClicked:boolean = false;
  codePrmo:any = "";
  codePromosActivated: any = [];
  eventCodePRomos: any = [];
  embededMode:boolean = false;
  EmailValidationMode:boolean = false;
  validationEmail: any;
  checkingEmalError: boolean = false;
  InFormationCheck: boolean = false;
  CheckName: any;
  CheckPname: any;
  CheckSociety: any;
  ticket: any;
  disablePricingSelection : boolean = false;
  housingPrincings: any;
  nberOfdaySelection:boolean = true;
  housingSelection:boolean = false;
  addHousingMode:boolean = false;
  joinHousingMode:boolean = false;
  housingGlobal:boolean = false;
  nbdaysArrays:any = [];
  nboOfDays: any = 0;
  housing:any;
  roomcodeTocheck:any;
  roomcodeResponse:any;
  viewOption:boolean = false;

  @ViewChild('contactFormModal') contactFormModal: ContactFormModalComponent;
  constructor( @Inject(WINDOW) private window: Window,
               @Inject(LOCAL_STORAGE) private localStorage: any,
               @Inject(PLATFORM_ID) private platformId: Object,
               /*private readonly metas: MetaService,*/
               private eventservice: FoEventsService,
               private route: ActivatedRoute,
               private router: Router,
               private bookingservice: BooKingservice,
               private elRef: ElementRef,
               private meta: Meta,
              /* private fb: FacebookService,*/
               private authService: AuthService,
               public  sanitizer: DomSanitizer,
               private translateService: TranslateService,
               public  functionUtils: FonctionUtiles) {
               this.route.params.subscribe(params => {
               if(params['inscriptionId'])
                 this.inscriptionId = +params['inscriptionId'];
                 if(params['id'])
                   this.id = +params['id'];
               });
  }

  ngOnInit() {
    this.loadTranslations();
    this.loadPrincingsHousings();
    if(this.bookingservice.retrieve('embededMode'))
       this.embededMode = this.bookingservice.retrieve('embededMode');
  }

  changeListener($event, prcings): void {
    this.eventCodePRomos = this.event1.codepromos.slice(0);
    this.Total = 0;
    this.nbreTicket = 0;
    for (let i = 0; i < prcings.length; i++) {
      if((this.getPricingPrice(prcings[i]) || this.getPricingPrice(prcings[i]) == 0 ) && prcings[i].nbreTicket > 0) {
        if(!prcings[i].open)
          this.Total += prcings[i].nbreTicket * this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
        else
          this.Total += this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
        this.nbreTicket += prcings[i].nbreTicket;
       // this.disablePricingSelection = true;
      }
    }
  }

  initSelection() {
    for(let i = 0; i < this.housingPrincings.length; i++) {
      this.housingPrincings[i].nbreTicket = 0;
    }
  }

  calulTotalHousingSelect(){
    this.initSelection();
    if(this.housing && this.housing.price) {
      this.housing.nbreTicket = this.nboOfDays;
      this.Total = parseFloat(this.housing.price) * parseInt(this.nboOfDays);
      /*if(this.viewOption && this.housing.label != 'Suite') {
        this.Total = parseFloat(this.housing.price) * parseInt(this.nboOfDays) + 15 * parseInt(this.nboOfDays);
      }*/
    }
    //console.log(this.housingPrincings)
  }


  initAllnbrTicket(prcings){
    for (let i = 0; i < prcings.length; i++) {
      prcings[i].nbreTicket = 0;
    }
  }

  loadPrincingsHousings() {
    this.getHousingPricings().then(res=>{
      console.log('ok');
      for (let i = 0; i <= 5; i++)
        this.nbdaysArrays.push(i);
    })
  }
  loadData(){
    this.getSubstractionRequest().then(res=>{
      console.log('ok');
    })
  }

  //nbofpersons :capacité de la chambre
  //number_of_stays :nombre de chambre disponible * capacité
  canSelectHousing(house) {
    return house.nbofpersons && this.nboOfDays > house.nbofpersons || house.ticketpayed >= house.number_of_stays
  }

  cleanHousigMode() {
    this.addHousingMode = false;
    this.joinHousingMode = false;
  }
  moveToAddHousingMode() {
    this.cleanHousigMode();
    this.housingGlobal = false;
    this.addHousingMode = true;
  }

  moveToJoinHousingMode() {
    this.cleanHousigMode();
    this.housingGlobal = false;
    this.joinHousingMode = true;
  }

  getSubstractionRequest(){
    return this.eventservice.getReegistrationRequests(this.inscriptionId).then(res=>{
      this.Inscription = res;
      this.id = res.event_id;
      this.getOrganisation();
      this.initAll();
    })
  }
  getHousingPricings(){
    return this.eventservice.getHousingPricingsType(this.id).then(res=>{
      this.housingPrincings = this.formatPricing(res.pricings);
      //res.event['codepromos'] = [];
      this.event1 = res.event;
      this.event1['codepromos'] = [];
      this.setDevises(this.event1);
      ///console.log("get event then");
      if (isPlatformBrowser(this.platformId))
        document.title = this.buildMetaDesc();
      this.objectiveRate = (this.event1.objectiveState / this.event1.objective) * 100;
      if(this.event1.password && this.event1.is_visible == 3) {
        this.isSecret = true;
      }
      // meta tags for sharing
      let days = this.daysarray;
      let months = this.monthsarray;
      let d = this.initEventStartDate();
      this.dayname = days[d.getDay()];
      this.hours = d.getHours();
      this.day = d.getDate();
      this.month = months[d.getMonth()];

    })
  }
  checkroomAvailability(){
    if(this.roomcodeTocheck) {
      this.roomcodeResponse = '';
      this.eventservice.checkroomavailability({'code': this.roomcodeTocheck,'nbtoBook':this.nboOfDays}).then(res =>{
        this.roomcodeResponse = res;
        //console.log(res);
        if(res.pricing) {
          let pricings = [];
          pricings.push(res.pricing);
          this.housingPrincings = this.formatPricing(pricings);
          this.housing = this.housingPrincings[0];
          console.log(this.housing);
          this.calulTotalHousingSelect()
        }
      })
    } else {
      alert('Vueilez saisir le code de la chambre');
    }
  }


  pricingReduction(pricing) {
    let reduction:number = 0;
    reduction += this.codePromoReduct(pricing);
    return reduction;
  }

  codePromoReduct(pricing) {

    if(pricing.codePromo && pricing.codePromo.reduction_simple )
      return  parseFloat(pricing.codePromo.reduction_simple);
    else if(pricing.codePromo && pricing.codePromo.reduction_by_percentage )
      return (this.getPricingPrice(pricing)* parseFloat(pricing.codePromo.reduction_by_percentage)/100);
    else if(pricing.codePromo && pricing.codePromo.reduction_type == "Gratuit")
      return this.getPricingPrice(pricing);
    else
      return 0;

  }

  orderReductionByPricing(pricing) {

    let reduction:number = 0;
    if(this.eventCodePRomos) {
      //répartir toutes les promostions lié a la commande sur chaque tarif quand il s'agit d'une reduction en pourcentage
      //s'il s'agit d'une reduction simple on reduit le premier tarif en une fois
      for(let i=0; i<this.eventCodePRomos.length; i++) {
        if(this.eventCodePRomos[i].reduction_simple ) {
          //répartir les reduction sur toutes les tickets
          reduction += this.eventCodePRomos[i].reduction_simple/this.functionUtils.calculSelectedPricingNumber(this.pricingsAndPrincingsInGroup);
          //console.log(this.functionUtils.calculSelectedPricingNumber(this.pricingsAndPrincingsInGroup));
        }
        else {
          // percentengage reduction on total order is sum of all pricing total percentage reduction
          reduction += (this.getPricingPrice(pricing) * this.eventCodePRomos[i].reduction_by_percentage)/100;
        }
      }
    }
    return reduction;

  }


  orderReductionByTicket(pricing) {
    let reduction:number = 0;
    if(this.eventCodePRomos) {
      //répartir toutes les promostions lié a la commande sur chaque tarif quand il s'agit d'une reduction en pourcentage
      //s'il s'agit d'une reduction simple on reduit le premier tarif en une fois
      for(let i=0; i<this.eventCodePRomos.length; i++) {
        if(this.eventCodePRomos[i].reduction_simple ) {
          //répartir les reduction sur toutes les tickets
          reduction += this.eventCodePRomos[i].reduction_simple/this.functionUtils.calculTicketsSelectedNumber(this.pricingsAndPrincingsInGroup);
        }
        else {
          // percentengage reduction on total order is sum of all pricing total percentage reduction
          reduction += (this.getPricingPrice(pricing) * this.eventCodePRomos[i].reduction_by_percentage)/100;
        }
      }
    }
    return reduction;
  }

  initAll() {

    if (isPlatformBrowser(this.platformId) && localStorage != undefined) {
      let url_string = window.location.href
      let url = new URL(url_string);
      //let urlID = url.searchParams.get("from");
      this.smartUrlId = url.searchParams.get("from");


      if (url_string.indexOf("inscriptionvalidation") > -1) {
          console.log('not validation');
          this.EmailValidationMode = true;
      }
    }

    for (let i = 0; i <= 25; i++)
      this.nbTicketArray.push(i);

    this.loadTranslations();

    this.getEvent().then(event => {

      this.setDevises(this.event1);
      ///console.log("get event then");
      if (isPlatformBrowser(this.platformId))
        document.title = this.buildMetaDesc();
        this.objectiveRate = (this.event1.objectiveState / this.event1.objective) * 100;
        if(this.event1.password && this.event1.is_visible == 3) {
          this.isSecret = true;
      }
      // meta tags for sharing
      let days = this.daysarray;
      let months = this.monthsarray;
      let d = this.initEventStartDate();
      this.dayname = days[d.getDay()];
      this.hours = d.getHours();
      this.day = d.getDate();
      this.month = months[d.getMonth()];
      console.log("get event then end");
      this.pricings = this.formatPricing(this.Inscription.accreditations);
      this.pricingsAndPrincingsInGroup =  this.formatPricing(this.Inscription.accreditations.slice(0));

    });
    console.log("init end");
  }



  setDevises(event) {

    if (event.currency) {
      this.devise = event.currency
    }
    else {
      this.devise = 'Eur'
    }

  }


  buildMetaDesc(): string {
    // TODO put back this.buildDate() in share msg
    return this.event1.name + ' - ' + this.event1.location_name +
      ' ' + this.front_event.book_on_akces_your_market_place
  }


  initEventStartDate() {
    let debut = (this.event1.start_date + ' ' + this.event1.start_hour);
    return new Date(debut.replace(/ /g, "T"));
  }

  initEventEndDate() {
    let closed = (this.event1.end_date + ' ' + this.event1.end_hour)
    return  new Date(closed.replace(/ /g, "T"));
  }


  getEvent(): Promise<any> {
    return this.eventservice.event(this.id).then(event => {
      console.log(event)
      event.has_ticketing = parseInt(event.has_ticketing);
      event['codepromos'] = [];
      this.event1 = event

    });
  }

  formatEvents(res) {
    for (let i=0;i<res.length;i++) {
      res[i].has_ticketing = parseInt(res[i].has_ticketing);
    }
    return res;

  }

  loadTranslations() {
    this.translateService.get('front_event').subscribe(
      value => {
        this.front_event = value;
        this.daysarray = value.daysarray.split(',');
        this.monthsarray = value.months.split(',');
        console.log('pricing header  '+value);
      }
    )
  }

  getPricing(): Promise<any> {
    return this.eventservice.pricing(this.id).then(pricings => {
      this.pricings = this.formatPricing(pricings);
      this.pricingsAndPrincingsInGroup =  this.formatPricing(pricings.slice(0));
    });
  }


  nl2br(str) {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
  }

  getUser() {
    return this.authService.getUser();
  }


  checkEventVisibility() {
    if (parseInt(this.event1.is_published) == 0) {
      return (this.getUser().id && this.getUser().role_id && ((this.event1.user_id == this.getUser().id) || this.getUser().role_id == 1))
    }
    else {
      return true;
    }
  }


  formatPricing(pricings) {
    for( let i = 0; i < pricings.length; i++ ) {
      if(pricings[i].is_visible)
        this.ticketNumber++;
        pricings[i].Totalplace = parseInt(pricings[i].Totalplace);
        pricings[i].description = this.nl2br(pricings[i].description)
        pricings[i].nbreTicket = 0;
        if (new Date(pricings[i].openDate.replace(/ /g, "T")).getTime() > new Date().getTime()) {
         pricings[i].IsComing = true;
        }
        if (pricings[i].endDate && new Date(pricings[i].endDate.replace(/ /g, "T")).getTime() < new Date().getTime())
         pricings[i].IsClosed = true;

        if (!pricings[i].devise) {

        if(this.event1.currency) {
           pricings[i].devise = this.event1.currency
        }
        else {
           pricings[i].devise = 'Eur'
        }
      }
      if(pricings[i].selectable_q) {
          pricings[i]['pricingSelectableArray'] = [];
         for (let m = 0; m < pricings[i].selectable_q+1; m++)
          pricings[i].pricingSelectableArray.push(m);
      }

    }
    return pricings;
  }

  event_has_Booking(event) {
      return event.has_ticketing || event.has_open_ticketing || event.has_registration_module;
  }

  getPricingPrice(pricing) {
      return this.functionUtils.getPricingPrice(pricing);
  }


  checkExhausted(pricing) {
    if (pricing.Totalplace <= '0' && pricing.Totalplace != -1 && pricing.ShowNbPlace) {
         return 'ticket-purpose alert-danger flexible line-though'
    }
    else {
         return 'bg-white ticket-purpose  flexible';
    }
  }

  minutesToMs(min) {
    return min * 60 * 1000;
  }

  bookingExpirationTime() {
    if(this.event1.booking_expiration)
      return this.minutesToMs(this.event1.booking_expiration);
    else
      return this.minutesToMs(15);
  }

  getVal(value) {
    if(value)
        return value;
    else
        return ' ';
  }

  buildLink(encoded?: boolean): string {
    if (!encoded) return this.router.url;
        return encodeURIComponent(this.router.url);
  }

  location() {
        return this.event1.adresse + ' ' + this.getVal(this.event1.zipcode) + ' ' + this.getVal(this.event1.city) + ' ' + this.getVal(this.event1.country);
  }

  buildDate(): string {
        return this.dayname + ' ' + this.day + ' ' + this.month;
  }

  buildShareMsg(): string {
    // TODO put back this.buildDate() in share msg
        return this.event1.name + ' - ' + this.event1.location_name +
        ' ' + this.front_event.book_on_akces_your_market_place + ': ' + this.router.url;
  }

  price(price) {
    if(price == 0)
        return 'Gratuit';
    else
        return price.toFixed(2) +' '+this.functionUtils.getPricingDeviseSymbole(this.event1.currency);
  }


  isDraft() {
        return parseInt(this.event1.is_published) === 0;
  }

  pricingIsToMuchSelected(pricing) {
        return (pricing.Totalplace < pricing.nbreTicket)&& (pricing.Totalplace!=-1)
  }


  isDraftCls() {
        return this.isDraft() ? "event-reservation--overlay" : "";
  }

  nbPlace(pricing) {

    if (pricing.Totalplace && pricing.Totalplace > 0 && pricing.ShowNbPlace) {
        return pricing.Totalplace + ' ' + this.front_event.remainings_tickets;
    }
    else if (pricing.Totalplace && pricing.Totalplace == 0 && pricing.ShowNbPlace) {
        return this.front_event.sold_out;
    }
    else if (pricing.Totalplace == -1 && pricing.ShowNbPlace) {
        return this.front_event.unlimited_number_of_place;
    }
  }


  // TODO #MEDIUM, translate in english next()
  poursuivre1(pricings): Promise<any> {


    this.order = new Order();
    this.order.total_price = this.Total.toFixed(2);
    this.order.event_id = this.event1.id;
    this.order.date = this.event1.date;
    this.order.smart_urlID = this.smartUrlId;
    //this.order.isRegistration = true;
    this.order['has_housing'] = true;
    this.order['capacity'] = this.housing.nbofpersons;
    this.order['pricing_id'] = this.housing.id;
    if(this.roomcodeResponse && this.roomcodeResponse.roombooking) {
      this.order['roombooking_id'] = this.roomcodeResponse.roombooking.id;
    }
    this.order.options = this.getOrderOptions();
    //event date or datenow?
    /*  for (let i=0; i<this.nbreTicket; i++) {
        let  ticket =new Ticket();
        ticket.pricing_id=this.pricing.id;
        ticket.event_id=this.id;
        ticket.id=i+1;
        this.tickets.push(ticket);
      }*/

    let id = 1;
    for (let i = 0; i < pricings.length; i++) {
      let booking = new BookingList();
      booking.Pricing_label = pricings[i].label;
      let t = [];
      if(pricings[i].codePromo && pricings[i].codePromo.reduction_type == "Gratuit") {
        //fist ticket ispromo true
        let ticket = new Ticket();
        ticket.pricing_id = pricings[i].id;
        ticket.event_id = this.id;
        ticket.id = id;
        ticket.pricing_label = pricings[i].label;
        ticket.substractionrequest_id = this.inscriptionId;
        ticket.isPromo = true;
        ticket.form = this.getTicketForm(pricings[i]);
        //concat buyer inputs
        this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
        id ++;
        t.push(ticket);
        for(let j=0; j<(pricings[i].nbreTicket-1); j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.substractionrequest_id = this.inscriptionId;
          ticket.pricing_label = pricings[i].label;
          //répartir la reduction promo du tarif sur tous les ticktes du tarifs
          //ticket.reduction += this.pricingReduction(pricings[i])/(pricings[i].nbreTicket-1);
          //ajouter la part de reduction de commande correspondant au ticket
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
        }
      } else {
        for (let j = 0; j < pricings[i].nbreTicket; j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          ticket.substractionrequest_id = this.inscriptionId;
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
        }

      }

      //promotion pricing group
      if (pricings[i].type == 'groupe' && pricings[i].nb_of_participants > 1) {
        let nombre = pricings[i].nbreTicket * pricings[i].nb_of_participants - pricings[i].nbreTicket;
        for (let k = 0; k < nombre; k++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.isPromo = true;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          ticket.form = this.getTicketForm(pricings[i]);
          id ++;
          t.push(ticket);
        }
      }
      booking.tickets = t;
      if(booking.tickets.length>0) {
        this.bookingLists.push(booking);
      }
    }
    console.log(this.order);

    //let sessionExpirationTime = new Date().getTime() +15*1000;
    this.bookingservice.store('order', this.order);
    this.bookingservice.store('bookingList', this.bookingLists);
    this.bookingservice.store('pricings', this.housingPrincings);
    this.bookingservice.store('event', this.event1);
    this.bookingservice.store('result', this.order);
    this.bookingservice.store('book','notDone');
    this.bookingservice.store('currenteventUrl',window.location.href);
    this.bookingservice.store('sessionExpirationTime',this.bookingExpirationTime());
    this.bookingservice.store('codePromosActivated',this.codePromosActivated);
    this.router.navigate(['/booking/infos']);
    return;
  }




  // TODO #MEDIUM, translate in english next()
  poursuivre(pricings): Promise<any> {

    if(this.nbreTicket >1 ) {
      this.Total = 0;
      this.nbreTicket = 0;
      this.initAllnbrTicket(pricings);
      alert('Vous ne pouvez réserver qu\'une seule accréditation');
      return;
    }
    //this.retriveCodeActivatedFromStorageAndPlyPricing();
    if (this.pricingGroups) {
      for (let i = 0; i < this.pricingGroups.length; i++) {
        for (let j = 0; j < this.pricingGroups[i].pricings.length; j++) {
          pricings.push(this.pricingGroups[i].pricings[j])
        }
      }
    }

    if (this.nbreTicket == 0) {
      console.log(this.nbreTicket);
      alert(this.front_event.enter_number_of_ticket);
      return;
    }

    for (let i = 0; i < pricings.length; i++) {

      if (pricings[i].Totalplace < pricings[i].nbreTicket && pricings[i].Totalplace != -1) {
        alert(this.front_event.your_order_more_ticket_than_available + ' ' + pricings[i].label);
        return;
      }
      if (pricings[i].open && pricings[i].price < 1) {
        alert(this.front_event.the_jackpot_must_be_more_than_1);
        return;
      }

    }

    this.order = new Order();
    this.order.total_price = this.Total.toFixed(2);
    this.order.event_id = this.event1.id;
    this.order.date = this.event1.date;
    this.order.smart_urlID = this.smartUrlId;
    this.order.isRegistration = true;
    //event date or datenow?
    /*  for (let i=0; i<this.nbreTicket; i++) {
        let  ticket =new Ticket();
        ticket.pricing_id=this.pricing.id;
        ticket.event_id=this.id;
        ticket.id=i+1;
        this.tickets.push(ticket);
      }*/
    let id = 1;
    for (let i = 0; i < pricings.length; i++) {
      let booking = new BookingList();
      booking.Pricing_label = pricings[i].label;
      let t = [];

      if(pricings[i].codePromo && pricings[i].codePromo.reduction_type == "Gratuit") {

        //fist ticket ispromo true
        let ticket = new Ticket();
        ticket.pricing_id = pricings[i].id;
        ticket.event_id = this.id;
        ticket.id = id;
        ticket.pricing_label = pricings[i].label;
        ticket.substractionrequest_id = this.inscriptionId;
        ticket.isPromo = true;
        ticket.form = this.getTicketForm(pricings[i]);
        //concat buyer inputs
        this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
        id ++;
        t.push(ticket);

        for(let j=0; j<(pricings[i].nbreTicket-1); j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.substractionrequest_id = this.inscriptionId;
          ticket.pricing_label = pricings[i].label;
          //répartir la reduction promo du tarif sur tous les ticktes du tarifs
          //ticket.reduction += this.pricingReduction(pricings[i])/(pricings[i].nbreTicket-1);
          //ajouter la part de reduction de commande correspondant au ticket
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
          }
      } else {
        for (let j = 0; j < pricings[i].nbreTicket; j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          ticket.substractionrequest_id = this.inscriptionId;
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
        }

      }

      //promotion pricing group
      if (pricings[i].type == 'groupe' && pricings[i].nb_of_participants > 1) {
        let nombre = pricings[i].nbreTicket * pricings[i].nb_of_participants - pricings[i].nbreTicket;
        for (let k = 0; k < nombre; k++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.isPromo = true;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          ticket.form = this.getTicketForm(pricings[i]);
          id ++;
          t.push(ticket);
        }
      }
      booking.tickets = t;
      if(booking.tickets.length>0) {
        this.bookingLists.push(booking);
      }
    }

    //let sessionExpirationTime = new Date().getTime() +15*1000;
    this.bookingservice.store('order', this.order);
    this.bookingservice.store('bookingList', this.bookingLists);
    this.bookingservice.store('pricings', this.pricingsAndPrincingsInGroup);
    this.bookingservice.store('event', this.event1);
    this.bookingservice.store('result', this.order);
    this.bookingservice.store('book','notDone');
    this.bookingservice.store('currenteventUrl',window.location.href);
    this.bookingservice.store('sessionExpirationTime',this.bookingExpirationTime());
    this.bookingservice.store('codePromosActivated',this.codePromosActivated);
    this.router.navigate(['/booking/infos']);
    return;
  }



  addValueAttribute(res) {
    //console.log(res);
    for(let i = 0;i <res.length; i++) {
      res[i]['value'] = '';
      res[i]['isValid'] = false;
      res[i]['touched'] = false;
    }
    return res;
  }

  //add props to inputs
  addvaluesToForm(form) {
    if(form && form.inputsTicket)
      this.addValueAttribute(form.inputsTicket);
    if(form && form.inputsOrder)
      this.addValueAttribute(form.inputsOrder);
    return form;
  }


  //check if input exist in array by label
  ExistInarray(arr1,string1) {
    for(let i=0;i<arr1.length;i++) {
      if(arr1[i].label==string1)
        return true;
    }
    return false;
  }

  //buyer inputs are sum all buyerinputs of all form
  addOtherOrderInputsToBuyerInputs(inputs ,form2) {
    if(form2 && form2.inputsOrder && inputs) {
      for(let i = 0; i < form2.inputsOrder.length; i++) {
        if(!this.ExistInarray(inputs,form2.inputsOrder[i].label)) {
          inputs.push(form2.inputsOrder[i]);
        }
      }
    }
  }



  //find form to add  to ticket
  getTicketForm(pricing) {
    if(pricing.form) {
      return this.addvaluesToForm(pricing.form);
    }
    else if(this.event1.form) {
      return this.addvaluesToForm(this.event1.form);
    }
    else {
      return this.addvaluesToForm(this.eventservice.DefaultForm());
    }
  }

  openContactModal() {
    this.contactFormModal.showModal();
  }


  getOrganisation(): Promise<any> {
    return this.eventservice.organisation(this.id).then(any => {
      if (any != 'not found') {
        this.organisaion = any;
        console.log(any)
      }
      console.log(this.organisaion)
    });
  }

  clean(){
    this.EmailValidationMode = false;
    this.InFormationCheck = false;
  }

  findInput(arr,string1) {
    for(let i=0;i<arr.length;i++) {
      if(arr[i].label == string1)
        return arr[i];
    }
    return false;
  }

  getSociety(inputTicket){
    if(this.findInput(inputTicket,'Société'))
       return this.findInput(inputTicket,'Société').value;
  }

  findAndSetFormInputValue(inputTicket,value){
    if(this.findInput(inputTicket,'Société'))
      this.findInput(inputTicket,'Société').value = value;
    }

    continueHousingBooking(){
      if(this.nboOfDays == 0){
        alert('sélectionnez le nombre de séjour pour continuer');
        return;
      }
      this.nberOfdaySelection = false;
      this.housingSelection = true;
      this.housingGlobal = true;
    }

  checkValidationEmailEmail(){
    if(this.validationEmail){
      this.checkingEmalError = false;
      let ValueForCheck = {'email':this.validationEmail,'substractionrequest_id':this.inscriptionId};
      this.eventservice.checkSubstractionEmail(ValueForCheck).then(res=> {
        if(res !='notfound') {
          this.clean();
          this.InFormationCheck = true;
          this.CheckName = res.firstname;
          this.CheckPname = res.lastname;
          this.ticket = res;
          this.CheckSociety = this.getSociety(res.inputsTicket);
        }
        else
          this.checkingEmalError = true;
      })
    }else
      alert('Vous devez entrer un email pour continuer')
  }

  CheckInfo(){
    this.ticket.firstname = this.CheckName;
    this.ticket.lastname  = this.CheckPname;
    this.findAndSetFormInputValue(this.ticket.inputsTicket,this.CheckSociety);
    console.log('ok info checked');
    this.bookingservice.store('isInscription',true);
    this.bookingservice.store('sessionExpirationTime',this.bookingExpirationTime());
    this.eventservice.SaveRegistrationData(this.ticket).then(res=> {
      this.bookingservice.store('inscriptionTicket',this.ticket);
      this.moveToCnfirm();
    });
  }

  moveToSuccess() {
    this.router.navigate(['inscription/payment/success']);
  }

  moveToCnfirm() {
    this.router.navigate(['inscription/confirm']);
  }


  orderisFree(total){
    return parseInt(total) == 0;
  }



  allPricingAreFree(pricings) {
    for(let i = 0; i < pricings.length; i++) {
      if(this.getPricingPrice(pricings[i])>0)
        return false;
    }
    return true;
  }
  getOrderOptions(){
    let options = [];
    if(this.viewOption) {
      let option = {};
      option['name'] = 'Vue sur la mer';
      option['price'] = 15;
      options.push(option);
      return options;
    } else {
      return options;
    }
  }

  viewOnCheck(){
    if(!this.housing) {
      alert('Vueillez choisir le logement');
     // return;
    }
    this.viewOption =! this.viewOption;
    this.calulTotalHousingSelect();
    console.log(this.viewOption);
  }



}
